import { Button, Empty } from 'antd';
import { useEffect, useState } from 'react';

// modals
import { Company, CompanyDocumentsResponse } from 'modules/users/models/companies';

// services
import NotificationService from 'core/services/notification';
import { onGetCompanyDocuments } from 'modules/users/services/users';
import { formatSnakeCase } from 'utils/textFormat';

// components
import LoadingComponent from 'components/loadingComponent/loadingComponent';

// images
import image from 'assets/images/image.png';
import doc from 'assets/images/doc.png';
import xls from 'assets/images/xls.png';
import pdf from 'assets/images/pdf.png';
import file from 'assets/images/text.png';
import { useTranslation } from 'react-i18next';
import NoData from 'components/noData/noData';

interface InputProps {
	userId: number;
	company: Company;
}

function CompanyDocumentsComponent({ company, userId }: InputProps) {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);

	const [documents, setDocuments] = useState<CompanyDocumentsResponse>();
	const [noDocuments, setNoDocuments] = useState<boolean>(true);

	useEffect(() => {
		if (company) {
			getDocuments();
		}
	}, [company]);

	const getDocuments = async () => {
		try {
			setIsLoading(true);
			setNoDocuments(true);

			const response = await onGetCompanyDocuments(userId, company.id);

			setDocuments(response.data.data);

			Object.entries(response.data.data).forEach(([key, value]) => {
				if (value) setNoDocuments(false);
			});

			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.OPS'), t('COMMON.ERROR_OCCURRED'));
		}
	};

	return (
		<>
			{isLoading || !documents ? (
				<LoadingComponent />
			) : (
				<div>
					{noDocuments ? (
						<NoData />
					) : (
						Object.entries(documents).map(
							([key, value], index) =>
								value && (
									<div className="d-flex align-items-center gap-2 py-2" key={index} style={{ borderBottom: '1px solid #eee' }}>
										<img
											src={
												value.mime_type == 'application/pdf'
													? pdf
													: value.mime_type == 'application/doc' || value.mime_type == 'application/docx'
													? doc
													: value.mime_type == 'text/csv' || value.mime_type == 'text/xls'
													? xls
													: value.mime_type == 'image/jpeg' || value.mime_type == 'image/jpg' || value.mime_type == 'image/png'
													? image
													: file
											}
											style={{ width: 60 }}
										/>

										<div>
											<h6 className="mb-1 fw-medium">{formatSnakeCase(key)}</h6>
											<p className="mb-1">
												<span className="fw-medium">{t('USERS.SIZE')} : </span>
												{value.size_in_kilobyte > 1000
													? `${(value.size_in_kilobyte / 1000).toFixed(1)} ${t('USERS.MB')}`
													: `${value.size_in_kilobyte.toFixed(0)} ${t('USERS.KB')}`}
											</p>
											<a href={value.download_link} target="_blank">
												<Button type="primary" style={{ padding: '5px 10px' }}>
													{t('COMMON.DOWNLOAD')}
												</Button>
											</a>
										</div>
									</div>
								),
						)
					)}
				</div>
			)}
		</>
	);
}

export default CompanyDocumentsComponent;
